import React from "react";
import VendorFooter from "../vendors/VendorFooter";
import MainFooter from "./MainFooter";

const Footer = ({ vendor }) => {
  return vendor ? <VendorFooter /> : <MainFooter />;
};

export default Footer;
